export default __webpack_public_path__ + "static/media/element_13.a0b45bbd.jpg";